// extracted by css-extract-rspack-plugin
export default {"container":"cXXx9FOJDVQNEFh3","link":"p2CtIH1dyrkQfNr8","logo":"WdGVznN5Lc51GhjR"};